import Axios from "axios"
import joinUrl from "url-join"

import { cacheInLocalStorage } from "@/lib/page-cache"

export default path => {
  if (path.startsWith("/me/")) return new Promise(r => r())

  const url = joinUrl(
    process.env.VUE_APP_APP_DATA_PATH,
    path === "/" ? "" : path,
    "index.json",
    `?ts=${new Date().getTime()}`
  )

  return Axios.get(url).then(res => {
    cacheInLocalStorage(path, res.data)

    return res.data
  })
}
